import React from "react";
import GetStarted from "../../components/getStarted/GetStarted";

const GetStartedPage = () => {
  return <GetStarted />;
};

export default GetStartedPage;
